import $ from 'jquery';
import moment from 'moment';
import Opening from '@/include/_opening';

var xhr = new XMLHttpRequest();

function SoundCtrl() {
	this.storage = window.sessionStorage;
	this.localStorage = window.localStorage;
	this.$win      = $(window);
	this.$body     = $('body');
	this.$switch   = $('.bgm-switch');
	this.$audio    = $('#audioCheck');
	this.$loading = $('#loading');
	this.$progressBar = $('#progress');
	this.$openingSkipInput = $('.opening-skip-input');
	this.$openingSkip = $('#openingSkip');
	this.$on = this.$audio.find('.sound-on');
	this.$off = this.$audio.find('.sound-off');
	this.audioPath = this.$audio.data('audio');
	this.response  = null;

	this.src = null;
	this.audio = new Audio(); // this.audioPath
	this.downloadCheck = false;


	this.audio.loop = true;
	this.$currentTime = 12;

	if (this.storage.getItem('opening') !== null && this.audio.currentTime) {
		this.audio.currentTime = this.$currentTime;
	}

	this.opening = new Opening();
	this.opening.init();

	this.getSound         = this.getSound.bind(this);
	this.openingFull      = this.openingFull.bind(this);
	this.openingOn        = this.openingOn.bind(this);
	this.openingOff       = this.openingOff.bind(this);
	this.openingSkip      = this.openingSkip.bind(this);
	this.openingSkipCheck = this.openingSkipCheck.bind(this);
	this.click            = this.click.bind(this);
	this.play             = this.play.bind(this);

	this.init();
}

SoundCtrl.prototype.init = function() {
	if (typeof this.$switch.get(0) === 'undefined') return;

	if (this.storage.getItem('opening') !== null || this.openingSkipCheck()) {
		const opening = new Opening();
		opening.remove();
		this.$audio.remove();
		this.$body.css({
			position: '',
			height: '',
			overflow: '',
		});
	}

	this.getSound();

	this.$switch.on('click', this.click);
	this.$on.on('click', this.openingOn);
	this.$off.on('click', this.openingOff);
	this.$openingSkip.on('change', this.openingSkip);
	this.audio.addEventListener('timeupdate', function() {
		if (this.currentTime > 93) {
			this.currentTime = 12;
		}
	});
}

SoundCtrl.prototype.getSound = function() {
	const self = this;

	this.$switch.addClass('muted');

	xhr.onload = function (response) {
		self.audio.src = window.URL.createObjectURL(this.response);
	}
	xhr.onprogress = function (e) {
		let bar = (100 * e.loaded / e.total | 0);
		self.$progressBar.find('.num').text(bar);
		self.$progressBar.find('.barline').css('width', bar + '%');
	}
	xhr.onloadend = function (e) {
		self.downloadCheck = true;
		self.$loading.addClass('remove');
		self.$loading.on('transitionend', function () {
			$(this).remove();
		})
	}
	xhr.onreadystatechange = function (e) {
		if (xhr.readyState === 4) {
			if (xhr.status === 200) {
				console.log('Download completed!');
			}
		}
	}

	xhr.open('GET', this.audioPath, true);
	xhr.responseType = 'blob';
	xhr.send(null);
}

SoundCtrl.prototype.click = function(e) {
	const _this = $(e.currentTarget);
	if (_this.hasClass('active')) {
		_this.removeClass('active').addClass('muted');
		this.pause();
	} else {
		_this.addClass('active').removeClass('muted');
		this.play();
	}
}

SoundCtrl.prototype.openingFull = function() {
	const opening = new Opening();
	if (this.storage.getItem('opening') === null) {
		console.info('Opening: Complete')
		this.storage.setItem('opening', 'complete');
		opening.init();
		opening.opBorder();
	} else {
		console.info('Opening: Removed!')
		opening.remove();
	}
}

SoundCtrl.prototype.openingStart = function() {
	this.storage.setItem('opening', 'complete');
	// this.opening.init();
	this.opening.opBorder();
}

SoundCtrl.prototype.openingRemove = function() {
	this.opening.remove();
}

SoundCtrl.prototype.openingOn = function() {
	this.$audio.removeClass('active');
	this.audio.play();
	this.openingStart();
	this.$switch.addClass('active');
}

SoundCtrl.prototype.openingOff = function() {
	this.$audio.removeClass('active');
	this.audio.pause();
	this.openingStart();
	this.$switch.removeClass('active');
}

SoundCtrl.prototype.openingSkip = function(e) {
	const self = this;
	const _this = $(e.currentTarget);
	var CurrentDate = moment().format('YYYY-MM-DD');
	if (self.$openingSkip.prop('checked')) {
		this.localStorage.setItem('openingSkip', CurrentDate);
	} else {
		this.localStorage.removeItem('openingSkip');
	}
}

SoundCtrl.prototype.openingSkipCheck = function(e) {
	const self = this;
	var CurrentDate = moment();
	var StorageDate = self.localStorage.getItem('openingSkip');

	if (StorageDate) {
		var fromDate = moment(StorageDate);
		var diff = CurrentDate.diff(fromDate, 'days');
		if (diff < 30) {
			return true;
		}
	}

	return false;
}

SoundCtrl.prototype.play = function() {
	this.audio.currentTime = this.$currentTime;
	this.audio.play();
}

SoundCtrl.prototype.pause = function() {
	this.$currentTime = this.audio.currentTime;
	this.audio.pause();
}

export default SoundCtrl;